import charlesRex from '../../../assets/avatars/charles-rex.svg';
import florenceGarcia from '../../../assets/avatars/florence-garcia.svg';
import liamEstrada from '../../../assets/avatars/liam-estrada.svg';
import melanieLee from '../../../assets/avatars/melanie-lee.svg';
import oliviaYang from '../../../assets/avatars/olivia-yang.svg';
import priyaHansra from '../../../assets/avatars/priya-hansra.svg';
import raulGonzalez from '../../../assets/avatars/raul-gonzalez.svg';
import robiLopez from '../../../assets/avatars/robi-lopez.svg';

export const surveyRespondentAvatars: Record<string, string> = {
	'priya-hansra': priyaHansra,
	'raul-gonzalez': raulGonzalez,
	'olivia-yang': oliviaYang,
	'liam-estrada': liamEstrada,
	'melanie-lee': melanieLee,
	'robi-lopez': robiLopez,
	'florence-garcia': florenceGarcia,
	'charles-rex': charlesRex,
};
